import { getGroupList } from "../api/generated/wrappers/group";
import { getGroupListWithPermission } from "../api/generated/wrappers/group";
import { createQueryKeys } from "./create-query-keys";
const groupQueryKeys = createQueryKeys("group", {
    all: () => ({
        queryKey: ["all"],
        queryFn: getGroupList,
    }),
    withPermission: () => ({
        queryKey: ["withPermission"],
        queryFn: getGroupListWithPermission,
    }),
});
export default groupQueryKeys;
